import { activeFilterCount } from "../utils/active-filter-count";
import { fetchFilteredResults } from "../utils/fetchFilteredResults";
import { updateView } from "./employees-view-toggler";

export const initEmployeeSearch = () => {
    const searchForm = document.querySelector<HTMLFormElement>(
        '[data-selector="employee-search-form"]',
    );
    const resultsContainer = document.querySelector<HTMLElement>(
        '[data-selector="search-results-list"]',
    );
    if (!searchForm || !resultsContainer) return;

    const filterHeading = searchForm.querySelector(
        '[data-slot="filter-title"] h3',
    );

    const updateFilterCount = () => {
        activeFilterCount({
            currentActive: searchForm.querySelectorAll(
                'input[type="checkbox"]:checked',
            ).length,
            filterHeading: filterHeading as HTMLElement,
        });
    };

    const submitForm = async () => {
        const formData = new FormData(searchForm);
        const params = new URLSearchParams();

        updateFilterCount();

        for (const [key, value] of formData.entries()) {
            if (value) params.append(key, value.toString());
        }

        const url = new URL(searchForm.action, window.location.origin);
        url.search = params.toString();

        await fetchFilteredResults(
            url.toString(),
            resultsContainer,
            '[data-selector="search-results-list"]',
        );

        updateView();
        window.history.pushState({}, "", url.toString());
    };

    updateFilterCount();

    searchForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        await submitForm();
    });

    searchForm.addEventListener(
        "input",
        (() => {
            let timeoutId: ReturnType<typeof setTimeout>;
            return () => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    searchForm.requestSubmit();
                }, 300);
            };
        })(),
    );
};
